import React from 'react'

import ContentLoader from 'react-content-loader'
import { useTranslation } from 'react-i18next'

const ProductNameLoader = () => {
  const { t } = useTranslation()

  return (
    <ContentLoader
      speed={2}
      width={500}
      height={64}
      viewBox='0 0 500 64'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
      title={t('loading')}
    >
      <rect x='15' y='22' rx='0' ry='0' width='400' height='20' />
    </ContentLoader>
  )
}

export default ProductNameLoader
